import { render, staticRenderFns } from "./ConcernEventNewsItem.vue?vue&type=template&id=0323bfd6&scoped=true"
import script from "./ConcernEventNewsItem.vue?vue&type=script&lang=js"
export * from "./ConcernEventNewsItem.vue?vue&type=script&lang=js"
import style0 from "./ConcernEventNewsItem.vue?vue&type=style&index=0&id=0323bfd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0323bfd6",
  null
  
)

export default component.exports